import {FC} from 'react'
import find from 'lodash/find'

type Props = {
  status: String
}

const statusList = [
  {
    id: 'paid',
    name: 'Paid',
    color: 'badge badge-light-success',
  },
  {
    id: 'partially_refunded',
    name: 'Partially refunded',
    color: 'badge badge-light-primary',
  },
  {
    id: 'refunded',
    name: 'Refunded',
    color: 'badge badge-light-info',
  },
  {
    id: 'pending',
    name: 'Unpaid',
    color: 'badge badge-light-danger',
  },
  {
    id: 'partially_paid',
    name: 'Partially paid',
    color: 'badge badge-light-warning',
  },
  {
    id: 'archived',
    name: 'Archived',
    color: 'badge badge-light-secondary',
  },
  {
    id: 'payment_failed',
    name: 'Failed',
    color: 'badge badge-light-danger',
  },

  {
    id: 'require_three_d_action',
    name: 'Require 3D',
    color: 'badge badge-light-danger',
  },

  {
    id: 'confirmed',
    name: 'Confirmed',
    color: 'badge badge-light-success',
  },
  {
    id: 'cancelled',
    name: 'Cancelled',
    color: 'badge badge-light-warning',
  },
  {
    id: 'rejected',
    name: 'Rejected',
    color: 'badge badge-light-warning',
  },
  {
    id: 'closed',
    name: 'Closed',
    color: 'badge badge-light-danger',
  },
  {
    id: 'error',
    name: 'Error',
    color: 'badge badge-light-danger',
  },
]

const PaymentStatus: FC<Props> = ({status}: any) => {
  if (status) {
    const obj = find(statusList, {id: status.toLowerCase()})
    return obj ? <span className={`badge ${obj.color}`}>{obj.name}</span> : status
  }
  return null
}

export default PaymentStatus
